export const VERIFY = 'VERIFY';
export const LINKED = 'LINKED';
export const SLACK_ACCOUNT_STATUS = { UNLINKED: 'UNLINKED', EMAIL_VERIFIED: 'EMAIL_VERIFIED' } as const;

export type SLACK_ACCOUNT_STATUS_TYPE = typeof SLACK_ACCOUNT_STATUS[keyof typeof SLACK_ACCOUNT_STATUS];
